import { AnalyticsSource } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import { SCREEN } from '@atlassian/jira-product-analytics-bridge';
import { MainIssueView } from './view.tsx';

export default AnalyticsSource('fullIssue', SCREEN)(MainIssueView);
